
      import API from "!../../../../../../node_modules/.pnpm/style-loader@3.3.4_webpack@5.90.0/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
      import domAPI from "!../../../../../../node_modules/.pnpm/style-loader@3.3.4_webpack@5.90.0/node_modules/style-loader/dist/runtime/styleDomAPI.js";
      import insertFn from "!../../../../../../node_modules/.pnpm/style-loader@3.3.4_webpack@5.90.0/node_modules/style-loader/dist/runtime/insertBySelector.js";
      import setAttributes from "!../../../../../../node_modules/.pnpm/style-loader@3.3.4_webpack@5.90.0/node_modules/style-loader/dist/runtime/setAttributesWithoutAttributes.js";
      import insertStyleElement from "!../../../../../../node_modules/.pnpm/style-loader@3.3.4_webpack@5.90.0/node_modules/style-loader/dist/runtime/insertStyleElement.js";
      import styleTagTransformFn from "!../../../../../../node_modules/.pnpm/style-loader@3.3.4_webpack@5.90.0/node_modules/style-loader/dist/runtime/styleTagTransform.js";
      import content, * as namedExport from "!!../../../../../../node_modules/.pnpm/css-loader@6.9.1_webpack@5.90.0/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[6].use[1]!../../../../../../node_modules/.pnpm/sass-loader@14.0.0_sass@1.70.0_webpack@5.90.0/node_modules/sass-loader/dist/cjs.js!../../../../../../node_modules/.pnpm/sass-resources-loader@2.2.5/node_modules/sass-resources-loader/lib/loader.js??ruleSet[1].rules[6].use[3]!./SimpleLayoutView.module.scss";
      
      

var options = {};

options.styleTagTransform = styleTagTransformFn;
options.setAttributes = setAttributes;

      options.insert = insertFn.bind(null, "head");
    
options.domAPI = domAPI;
options.insertStyleElement = insertStyleElement;

var update = API(content, options);



export * from "!!../../../../../../node_modules/.pnpm/css-loader@6.9.1_webpack@5.90.0/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[6].use[1]!../../../../../../node_modules/.pnpm/sass-loader@14.0.0_sass@1.70.0_webpack@5.90.0/node_modules/sass-loader/dist/cjs.js!../../../../../../node_modules/.pnpm/sass-resources-loader@2.2.5/node_modules/sass-resources-loader/lib/loader.js??ruleSet[1].rules[6].use[3]!./SimpleLayoutView.module.scss";
       export default content && content.locals ? content.locals : undefined;
